/* Change this file to get your personal Porfolio */

//SEO Related settings
const seo = {
  title: "Vikash Singh",
  og: {
    title: "Vikash Singh Portfolio",
    type: "website",
    url: "https://vikash12singh.github.io/",
  },
};

//Home Page
const greeting = {
  title: "Vikash Singh",
  logo_name: "Vikash Singh",
  developer_pic: "vikash41.jpg",
  developer_alt_name: "Vikash Singh",
  subTitle: "A passionate Full-Stack Web and Android app Developer",
  resumeLink:
    // "https://drive.google.com/file/d/1eUpyYZ90pPGop5LEUUJZ1gBofafQKx60/view?usp=sharing",
    "https://drive.google.com/file/d/1KNc4zdz-Ucye6JMTT4cnJJYM_uoghnA9/view?usp=sharing",
  contact_me: "/#/contact",
  fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
  backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
};

const socialMediaLinks = [
  {
    name: "Github",
    link: "https://github.com/Vikash29Singh",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/vikash-singh-484551152/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "Gmail",
    link: "mailto:singhvikash29@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  {
    name: "Twitter",
    link: "https://twitter.com/imvikash18",
    fontAwesomeIcon: "fa-twitter", // Reference https://fontawesome.com/icons/twitter?style=brands
    backgroundColor: "#1DA1F2", // Reference https://simpleicons.org/?q=twitter
  },
  {
    name: "Instagram",
    link: "https://www.instagram.com/vikash_s29/",
    fontAwesomeIcon: "fa-instagram", // Reference https://fontawesome.com/icons/instagram?style=brands
    backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
  },
  {
    name: "Medium",
    link: "https://vikashlikes18.medium.com/",
    fontAwesomeIcon: "fa-medium", // Reference https://fontawesome.com/icons/medium?style=brands
    backgroundColor: "#000000", // Reference https://simpleicons.org/?q=medium
  }
];

const skills = {
  data: [
    {
      // title: "Data Science",
      // fileName: "DataScienceImg",
      skills: [
        "- Basic experience of working with Selenium",
        "- Basic quantitative modelling for dynamic forecasting and time series analysis",
        "- Designed portfolio with React",
        "- Experience of working with Android Studio(Java)",
        "- Basic knowledge of Figma",
        "- Basic knowledge of creating application backend in Node, Express",
        "- Experience of working on multiple cloud platforms",
        "- Hosting and maintaining websites on virtual machine instances along with integration of databases",
      ],
      softwareSkills: [
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "simple-icons:node-dot-js",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "Java",
          fontAwesomeClassname: "simple-icons:java",
          style: {
            color: "#5382a1",
          },
        },
        {
          skillName: "NPM",
          fontAwesomeClassname: "simple-icons:npm",
          style: {
            color: "#CB3837",
          },
        },
        {
          skillName: "Android",
          fontAwesomeClassname: "simple-icons:android",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "PHP",
          fontAwesomeClassname: "simple-icons:php",
          style: {
            color: "#8993be",
          },
        },
        // {
        //   skillName: "Adobe XD",
        //   fontAwesomeClassname: "simple-icons:adobexd",
        //   style: {
        //     color: "#450135",
        //   },
        // },
        {
          skillName: "Figma",
          fontAwesomeClassname: "simple-icons:figma",
          style: {
            color: "#F24E1E",
          },
        },
        {
          skillName: "GCP",
          fontAwesomeClassname: "simple-icons:googlecloud",
          style: {
            color: "#4285F4",
          },
        },
        {
          skillName: "Firebase",
          fontAwesomeClassname: "simple-icons:firebase",
          style: {
            color: "#FFCA28",
          },
        },
        {
          skillName: "MySql",
          fontAwesomeClassname: "simple-icons:mysql",
          style: {
            color: "#00758F",
          },
        },
      ],
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "HackerRank",
      iconifyClassname: "simple-icons:hackerrank",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://www.hackerrank.com/vikz29",
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Christ (Deemed to be University)",
      subtitle: "MCA - Master of Computer Application",
      alt_name: "Christ (Deemed to be University)",
      duration: "2018 - 2021",
      descriptions: [
        "⚡ I studied basic new software engineering subjects like MicroProcessor(8085),Network Security,AI,Cloud Computing etc.",
        "⚡ Runner Up in cricket(also captain),football in Departmental fest - Revelation.",
        "⚡ I was also a part/event head of a couple of events organised by the department.",
        "⚡ I was part of the website development team as a backend developer.",
      ],
      website_link: "https://www.christuniversity.in/",
    },
    {
      title: "North Eastern Regional Institute of Management(NERIM)",
      subtitle: "BCA - Bachelor of Computer Application",
      alt_name: "NERIM",
      duration: "2016 - 2018",
      descriptions: [
        "⚡ I have studied basic software engineering subjects like DS, Algorithms, RDBMS, JAVA.",
        "⚡ Participated in the sports event",
      ],
      website_link: "http://www.nerimindia.org/",
    },
    {
      title: "Maharishi Vidya Mandir-IV CBSE",
      subtitle: "10,12-Commerce",
      // logo_path: "mvm.png",
      alt_name: "MVM-IV",
      duration: "2013 - 2015",
      descriptions: [
        "⚡ Completed my matriculation in the year 2013",
        "⚡ Completed my 12th-Commerce in the year 2015",
      ],
      website_link: "http://mvmguwahati-4.org/index.mvm",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Machine Learning for All",
      subtitle: "- Dr Marco Gillies",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/GUSCKD7HYFR8",
      alt_name: "Deep Learning.AI",
      color_code: "#00000099",
    },
    {
      title: "UX Design Fundamentals",
      subtitle: "- Micheal Worthington",
      logo_path: "ui_ux.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/HFAVUQUWMFR2",
      alt_name: "California Institute of the Arts",
      color_code: "  #18a4c7",
    },
    {
      title: "AI For Everyone",
      subtitle: "- Andrew Ng",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/UH9SB9ED6CZW",
      alt_name: "deeplearning.ai",
      color_code: "#00000099",
    },
    {
      title: "Python and Statistics for Financial Analysis",
      subtitle: "- Xuhu Wan",
      logo_path: "python_statistic.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/RVH7DP5VES3U",
      alt_name: "Python and Statistics for Financial Analysis",
      color_code: "#1F70C1ff",
    },
    {
      title: "Badges: Qwiklabs",
      subtitle: "- Qwiklabs",
      logo_path: "qwiklabs.png",
      certificate_link:
        "https://run.qwiklabs.com/public_profiles/71cfcd3a-653e-47d4-b8b2-b058652c0482",
      alt_name: "Google",
      color_code: "#ffffff",
    },
    {
      title: "Cross Platform Mobile App Development",
      subtitle: "- ATS Learning Solutions",
      logo_path: "ats_learning.png",
      certificate_link:
        "https://drive.google.com/file/d/1nsScgACCicfoyg8IaMXDIDKrCNXwgvju/view?usp=sharing",
      alt_name: "ATS Learning Solution",
      color_code: "#ffffff",
    },
    {
      title: "Beginner PHP and MySQL Tutorial",
      subtitle: "- Infinite Skills",
      logo_path: "udemy.png",
      certificate_link: "https://www.udemy.com/certificate/UC-SHUPJDCK/",
      alt_name: "Google",
      color_code: "#ffffff",
    },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Internship and Volunteership",
  description:
    // "I have worked with many evolving startups as ML and DL Developer, Designer and Software Architect. I have also worked with some well established companies mostly as AI Developer. I love organising events and that is why I am also involved with many opensource communities as a representative.",
    "I have worked with government body, college and startup as web and android app Developer. I have also contributed to the opensource communities.",
  header_image_path: "experience.svg",
  sections: [
    // {
    //   title: "Work",
    //   experiences: [
    //     {
    //       title: "Associate AI Engineer",
    //       company: "Legato Health Technology",
    //       company_url: "https://legatohealthtech.com/",
    //       logo_path: "legato_logo.png",
    //       duration: "June 2020 - PRESENT",
    //       location: "Hyderabad, Telangana",
    //       description:
    //         "I am working on automating healthcare products. The projects involve automation for process improvements and for significantly enhancing the profits. I am currently working on Cancer Survival and Reoccurence Prediction. Our goal is to make AI system which scales and removes doctor dependency as much as possible.",
    //       color: "#0879bf",
    //     },
    //     {
    //       title: "Android and ML Developer",
    //       company: "Muffito Incorporation",
    //       company_url: "https://www.linkedin.com/company/muffito-inc/about/",
    //       logo_path: "muffito_logo.png",
    //       duration: "May 2018 - Oct 2018",
    //       location: "Pune, Maharashtra",
    //       description:
    //         "I have created complete Android Application for locating Pub, Bar and beverage shops around you. I have also worked on implementation of algorithms for Face Detection, Text extraction from Image. I was involved in a team for creating complete software architecure of mobile and web application as well as admin panel for company.",
    //       color: "#9b1578",
    //     },
    //     {
    //       title: "Android Developer",
    //       company: "FreeCopy Pvt. Ltd.",
    //       company_url: "https://www.linkedin.com/company/freecopy/about/",
    //       logo_path: "freecopy_logo.png",
    //       duration: "Nov 2017 - Dec 2017",
    //       location: "Ahmedabad, Gujarat",
    //       description:
    //         "FreeCopy is the Start up from Indian Institute of Management, Ahmedabad. I have changed the integration of the whole app from Google to Firebase. I learnt the efﬁcient ways of Data communications like Retroﬁt, Eventbus etc. I experienced the real time start up. I learnt the Design thinking of UI on perspective of People.",
    //       color: "#fc1f20",
    //     },
    //   ],
    // },
    {
      title: "Internships",
      experiences: [
        {
          title: "Full Stack Developer - Intern",
          company: "Humanoid System",
          company_url: "#",
          logo_path: "humanoid_system.png",
          duration: "December 2020 - March 2021",
          location: "Work From Home",
          description:
            "This is a startup company. I was responsible for developing web admin panel for the Stallion group of industries called Africar(Ride-Hailing).",
          color: "#0071C5",
        },
        {
          title: "Full Stack Developer - Intern",
          company: " Assam Power Distribution Company Limited",
          company_url: "https://www.apdcl.org/website/",
          logo_path: "apdcl.png",
          duration: "January 2018 - April 2018",
          location: "Guwahati, Assam",
          description:
            "I developed a standalone android app to monitor the power supply in the Assam circle. Also, a module of the web panel was developed for the employee to keep track of power supply status,track bill status etc. MySQL was used as a backend database.",
          color: "#ee3c26",
        },
      ],
    },
    {
      title: "Volunteerships",
      experiences: [
        {
          title: "Gateways 2020 Techovid",
          company: "Christ (Deemed to be University)",
          company_url: "https://gateways.khudabadisonara.in/",
          logo_path: "christ.png",
          duration: "September 2020 - October 2020",
          location: "Bangalore, Karnataka",
          description:
            "Techovid's website was designed for students all over India to participate in the national 'Gateways 2020 virtual fest' organized by our university.",
          color: "#4285F4",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "The projects listed below were implemented as academic projects. ",
  avatar_image_path: "projects_image.svg",
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    description:
      "I am available on social media. You can ping me, I will reply within 24 hours. I can help you with Android, Web Development and Cloud.",
  },
  addressSection: {
    title: "Address",
    subtitle:
      "New Colony, P.O. -Basistha Chariali, Dist.-Kamrup(M), Assam - 781029",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://goo.gl/maps/UFRWGifdasEi3Mgx6",
  },
  phoneSection: {
    title: "Phone Number",
    subtitle: "+91 8876041514",
    whatsapp_link: "https://wa.me/918876041514",
  },
};

export {
  // settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  contactPageData,
};
